<template>
  <div class="airOpen-content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="number" label="编号" width="100"> </el-table-column>
      <el-table-column prop="name" label="空开名称"> </el-table-column>
      <el-table-column
        label="在线状态"
        sortable
        width="140"
        align="center"
      >
        <template slot-scope="scope">
          <i :class="steColorType[scope.row.is_online]"></i>
          <span>{{ steType[scope.row.is_online] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="添加时间"> </el-table-column>
      <el-table-column
        label="关闸/开闸"
        align="center"
        >
        <template slot-scope="scope">
            <el-switch
              v-model="scope.row.states"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
              @change="changeStates(scope.row.id,$event)"
              />
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
            
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="140px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item label="编号" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

  </div>
</template>

<script>
import airOpenApi from "@/api/light/airOpen";
export default {
  data() {
    return {
      steType: ["离线", "在线"],
      steColorType: ["valuered", "valuegreen"],
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      editOneRule: {
        number: [{ required: true, message: "请输入编号", trigger: "blur" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      editType: -1,
      editOne: {
        name: '',
        number: ''
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      airOpenApi.airOpenList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);

        }
      });
    },
    
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          number: ''
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          number: index.number
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      airOpenApi.airOpenEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      airOpenApi.airOpenAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        airOpenApi.airOpenDel(id).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("删除成功");
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    changeStates(id, value) { //开关闸
      airOpenApi.airOpenControl(id,{ type: 0 }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        }else{
          this.$message.error(res.data.message);
        }
      });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less' scoped>
.airOpen-content {
  width: 100%;
}


</style>